import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../plugins/feathersClient';

class StaffRates extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'StaffRate';

  // Define default properties here
  static instanceDefaults() {
    return {
      id: '',
      value: '',
      nightValue: ''
    };
  }
}
const servicePath = 'staff-rates';
const servicePlugin = makeServicePlugin({
  Model: StaffRates,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
